import { Button, Form } from "@app/components";
import { ConnectorSelect } from "@app/components/form/selects/features/ConnectorSelect";
import { Modal } from "@app/components/modals";
import { useToast } from "@app/hooks";
import { useModal } from "@app/hooks/useModal";
import { catalogSnapshotApi, modalsSelectors } from "@app/store";
import { useAppSelector } from "@app/store/hooks";
import { useForm } from "react-hook-form";

interface CatalogSnapshotPublishModalProps {
  id: string;
}

const extractApiCustomMessage = (error: any) => {
  return error?.data?.data?.message;
}

export const CatalogSnapshotPublishModalId = 'CatalogSnapshotPublishModal';

export const CatalogSnapshotPublishModal = ({ id }: CatalogSnapshotPublishModalProps) => {
  const toast = useToast();
  const modal = useModal(id);

  const modalData = useAppSelector(state => modalsSelectors.selectById(state, id));

  const [publish, { isLoading, error: apiErrors }] = catalogSnapshotApi.usePublishCatalogSnapshotMutation();

  const formMethods = useForm({
    defaultValues: {
      connector: undefined,
    },
  });

  const onPublish = async (params: any) => {
    const { catalogSnapshotId } = modalData?.data as { catalogSnapshotId: string; }

    try {
      await publish({ catalogSnapshotId, ...params }).unwrap();

      formMethods.reset();

      toast.success('Votre catalogue à bien été republié.')
    } catch (error) {
      const message = extractApiCustomMessage(error) || 'Une erreur est survenue lors de la republication du catalogue.';

      toast.error(message, { autoClose: 5000 })
    }

    modal.close();
  }

  return (
    <Modal isOpen={!!modalData?.isOpen}>
      <Modal.Title>Informations</Modal.Title>

      <Modal.Subtitle>Vous allez republier ce catalogue</Modal.Subtitle>

      <Modal.Message>
      </Modal.Message>

      <Form formMethods={formMethods} apiErrors={apiErrors}>
        <ConnectorSelect name="connector" />
      </Form>

      <Modal.Action>
        <Button title='Annuler' onPress={() => modal.close()} large />
        <Button title='Publier' onPress={formMethods.handleSubmit(onPublish)} large bordered loading={isLoading} />
      </Modal.Action>
    </Modal>
  );
}